<template>
  <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <div id="modulesContainer" class="modulesContainer" v-dragscroll>
        <ul id="modules" class="modules flow_chart justify-center content-center">
          <template v-if="modules">
            <h5 class="text-center pt-20 pb-10 font-semibold triggerText">
              Your <span class="textEmphasis">Clik</span> will start when this trigger occurs
            </h5>
            <template v-for="module in modules">
              <node-tree
                @openAddModulePopup="openAddModulePopup"
                @toggleModulesSidebar="toggleModulesSidebar('add-trigger', module)"
                @openLogPopup="openLogPopup"
                @openEditPopup="openEditPopup"
                @deleteModule="deleteModule"
                :module="module"
                :key="module.id"
                :exec_id="exec_id"
              ></node-tree>
            </template>
          </template>
        </ul>
      </div>
      <vs-popup
        class="logPopup"
        v-if="logPopup"
        :active.sync="logPopup"
        :title="`${focusedModule.title} Output Log Viewer`"
      >
        <vs-row>
          <vs-col>
            <div class="terminal">{{ focusedModule.log }}</div>
            <input type="hidden" id="log" :value="focusedModule.log">
            <vs-row vs-justify="flex-end" class="pt-4 pr-2 relative bottom-0">
              <vs-button color="rgba(var(--vs-dark), .7)" type="filled" @click.stop.prevent="copyLog" class="my-6 mr-6">Copy to clipboard</vs-button>
              <vs-button color="primary" type="filled" @click.stop.prevent="downloadLog" class="my-6 mr-6">Download</vs-button>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-popup>
      <edit-module
        v-if="focusedModule && focusedModule.action_type !== 'trigger-placeholder'"
        :moduleCopyProp="focusedModule"
        :editPopupProp="editPopup"
        @updateEditPopupState="updateEditPopupState"
        @updateModule="updateModule"
        @updateFocusedModule="updateFocusedModule"
        @saveClik="saveClik"
      ></edit-module>
      <vs-popup
        class="addModulePopup"
        :active.sync="addModulePopup"
        classContent="add-module-popup__content"
        title="Add a module"
      >
        <vs-row>
          <vs-col>
            <p class="my-4">Where would you like to add a module?</p>
          </vs-col>
        </vs-row>
        <template v-if="focusedModule">
          <template v-if="focusedModule.children.length">
            <vs-button
              id="add-child-between"
              color="primary"
              type="flat"
              class="mr-4 addChildButton"
              @click="toggleModulesSidebar('add-child-between')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 81"
              >
                <path
                  d="M10,19a9.5,9.5,0,1,1,9.5-9.5A9.51,9.51,0,0,1,10,19ZM10,2a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,10,2Z"
                  fill="#7368f0"
                />
                <g opacity="0.1">
                  <path d="M10,60a1.5,1.5,0,0,1-1.5-1.5v-5a1.5,1.5,0,0,1,3,0v5A1.5,1.5,0,0,1,10,60Z" />
                </g>
                <g opacity="0.25">
                  <path d="M10,81a9.5,9.5,0,1,1,9.5-9.5A9.51,9.51,0,0,1,10,81Zm0-17a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,10,64Z" />
                </g>
                <path
                  d="M10,30.5h0a10,10,0,0,1,10,10h0a10,10,0,0,1-10,10h0a10,10,0,0,1-10-10H0A10,10,0,0,1,10,30.5Z"
                  fill="none"
                />
                <path
                  d="M10,50.5a10,10,0,1,1,10-10A10,10,0,0,1,10,50.5Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,10,32.5Z"
                  fill="#7368f0"
                />
                <path
                  d="M14.07,41.08h-3.5v3.5H9.43v-3.5H5.93V39.93h3.5v-3.5h1.14v3.5h3.5Z"
                  fill="#7368f0"
                />
                <path
                  d="M10,29a1.5,1.5,0,0,1-1.5-1.5v-5a1.5,1.5,0,0,1,3,0v5A1.5,1.5,0,0,1,10,29Z"
                  fill="#7368f0"
                />
              </svg>
            </vs-button>
            <vs-button
              id="add-child"
              color="primary"
              type="flat"
              class="addChildButton"
              @click="toggleModulesSidebar('add-child')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48.5 74.5"
              >
                <g id="Group_51" data-name="Group 51">
                  <g id="Rectangle_50" data-name="Rectangle 50">
                    <path
                      d="M9.5,19A9.5,9.5,0,1,1,19,9.5,9.51,9.51,0,0,1,9.5,19Zm0-17A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.5,2Z"
                      fill="#7368f0"
                    />
                  </g>
                  <g opacity="0.1">
                    <path d="M8,29v22.7a1.5,1.5,0,0,0,3,0V32.22A12.89,12.89,0,0,1,8,29Z" />
                  </g>
                  <g id="Rectangle_53" data-name="Rectangle 53" opacity="0.25">
                    <path d="M9.5,74A9.5,9.5,0,1,1,19,64.5,9.51,9.51,0,0,1,9.5,74Zm0-17A7.5,7.5,0,1,0,17,64.5,7.5,7.5,0,0,0,9.5,57Z" />
                  </g>
                  <g id="Group_53" data-name="Group 53">
                    <g id="Rectangle_52" data-name="Rectangle 52">
                      <path
                        d="M38.5,54.5h0a10,10,0,0,1,10,10h0a10,10,0,0,1-10,10h0a10,10,0,0,1-10-10h0A10,10,0,0,1,38.5,54.5Z"
                        fill="none"
                      />
                      <path
                        d="M38.5,74.5a10,10,0,1,1,10-10A10,10,0,0,1,38.5,74.5Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,38.5,56.5Z"
                        fill="#7368f0"
                      />
                    </g>
                    <g id="Path_21" data-name="Path 21">
                      <path
                        d="M42.57,65.08h-3.5v3.5H37.93v-3.5h-3.5V63.93h3.5v-3.5h1.14v3.5h3.5Z"
                        fill="#7368f0"
                      />
                    </g>
                  </g>
                  <g id="Path_18" data-name="Path 18">
                    <path
                      d="M38.27,53.13a1.5,1.5,0,0,1-1.5-1.5c0-7.57-8.52-12.16-16-16.22C14.16,31.87,8,28.52,8,23.32a1.5,1.5,0,0,1,3,0c0,3.41,5.44,6.34,11.2,9.45,8.26,4.46,17.62,9.5,17.62,18.86A1.5,1.5,0,0,1,38.27,53.13Z"
                      fill="#7368f0"
                    />
                  </g>
                </g>
              </svg>
            </vs-button>
          </template>
          <template v-else>
            <vs-button
              id="add-new-child"
              color="primary"
              type="flat"
              class="mr-4 addChildButton"
              @click="toggleModulesSidebar('add-child')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 76.5"
              >
                <g id="Group_51" data-name="Group 51">
                  <g id="Rectangle_50" data-name="Rectangle 50">
                    <path
                      d="M10,19a9.5,9.5,0,1,1,9.5-9.5A9.51,9.51,0,0,1,10,19ZM10,2a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,10,2Z"
                      fill="#7368f0"
                    />
                  </g>
                  <g id="Rectangle_51" data-name="Rectangle 51">
                    <path
                      d="M10,23h0a.5.5,0,0,1,.5.5v28a.5.5,0,0,1-.5.5h0a.5.5,0,0,1-.5-.5v-28A.5.5,0,0,1,10,23Z"
                      fill="#fff"
                    />
                    <path
                      d="M10,53a1.5,1.5,0,0,1-1.5-1.5v-28a1.5,1.5,0,0,1,3,0v28A1.5,1.5,0,0,1,10,53Z"
                      fill="#7368f0"
                    />
                  </g>
                  <g id="Group_50" data-name="Group 50">
                    <g id="Rectangle_52" data-name="Rectangle 52">
                      <path
                        d="M10,56.5h0a10,10,0,0,1,10,10h0a10,10,0,0,1-10,10h0a10,10,0,0,1-10-10H0A10,10,0,0,1,10,56.5Z"
                        fill="none"
                      />
                      <path
                        d="M10,76.5a10,10,0,1,1,10-10A10,10,0,0,1,10,76.5Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,10,58.5Z"
                        fill="#7368f0"
                      />
                    </g>
                    <g id="Path_22" data-name="Path 22">
                      <path
                        d="M14.07,67.08h-3.5v3.5H9.43v-3.5H5.93V65.93h3.5v-3.5h1.14v3.5h3.5Z"
                        fill="#7368f0"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </vs-button>
          </template>
        </template>
      </vs-popup>
    </vs-col>
  </vs-row>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'
// import Vue from 'vue'
import { dragscroll } from 'vue-dragscroll'
import { jsPlumb } from 'jsplumb'
import nodeTree from './components/nodeTree.vue'
import editModule from './components/editModule.vue'

export default {
  name: 'Clik',
  props: ['clikID', 'exec_id'],
  components: {
    'node-tree': nodeTree,
    'edit-module': editModule
  },
  data () {
    return {
      clik: {
        id: '12345'
      },
      modules: [],
      addModulePopup: false,
      logPopup: false,
      editPopup: false,
      focusedModule: null
    }
  },
  computed: {
    downloadLogLink () {
      const $this = this
      let file = null
      const data = []
      data.push($this.focusedModule.log)

      // Specify the file's mime-type.
      const properties = {type: 'text/plain'}
      try {
        // Specify the filename using the File constructor
        file = new File(data, 'file.txt', properties)
      } catch (e) {
        // fall back to the Blob constructor if that isn't supported.
        file = new Blob(data, properties)
      }
      const url = URL.createObjectURL(file)
      return url
    }
  },
  methods: {
    createFlow () {
      const $this = this

      // remove all the currently existing connectors (if any)
      $('.jtk-connector').remove()

      // creates a ref for the jsPlumb instance and sets important parameters
      const instance = jsPlumb.getInstance({
        Connector: ['Flowchart', { cornerRadius: 100, gap: -70, midpoint: .5 }],
        Endpoint: ['Blank', { radius: 1, cssClass: 'endpoint' }],
        PaintStyle: { strokeWidth:7, stroke: '#c8d3ea' },
        Container: 'modules'
      })

      // sets the referenced instance to it's initial state
      instance.reset()

      // creates a batch function that stops jsplumb from repainting as the internal functions run
      instance.batch(() => {
        $this.triggerCheck()
        $this.addIDs()

        // run createFlow after Vue has a tick to reset its module element positions.
        $this.$nextTick(() => {
          $this.addEndpoints($this.modules, null, instance)
          $this.connectModules($this.modules, instance)
        })
      })
    },

    /**
     * Check to see if first module is trigger module, if not add placeholder.
     */
    triggerCheck () {
      const $this = this
      const child = _.cloneDeep($this.modules)

      const modulesWithTrigger = [
        {
          action_type: 'trigger-placeholder',
          children: child,
          id: 'trigger-placeholder',
          parent: null,
          title: null,
          scenarios: []
        }
      ]
      if ($this.modules.length === 0) {
        // console.log('triggerCheck() no modules?', $this.modules.length === 0)
        $this.$set($this, 'modules', modulesWithTrigger)
      } else if ($this.modules[0].action_type !== 'trigger-placeholder' && $this.modules[0].action_type !== 'trigger') {
        // console.log('triggerCheck() placeholder found?', $this.modules[0].type !== 'trigger-placeholder')
        // console.log('triggerCheck() trigger found?', $this.modules[0].type !== 'trigger')
        $this.$set($this, 'modules', modulesWithTrigger)
      }
    },

    /**
     * Add incrementing ID to all modules recursively
     */
    addIDs () {
      const $this = this

      // set iterator for ID
      let i = 1

      function addIDsRecusively (modules) {
        _.each(modules, function (module) {
          module.id = `${i}`
          i++
          if (module.children) addIDsRecusively(module.children)
        })
      }
      addIDsRecusively($this.modules)
    },

    /**
     * Recursively adds endpoints to all generated module elements on the page based on the nested objects within modules.
     * required for connectModules() to work.
     * params: modules, parentObject, jsPlumb instance
     * called by: createFlow()
     */
    addEndpoints (modules, parentObject, instance) {

      const $this = this
      _.each(modules, function (module) {
        // delete a module's parent to correct for changes to the tree structure
        module.parent = null

        const endPoint = `${module.id}-bottom`
        const sourcePoint = `${module.id}-top`

        // add endpoints to the top and bottom of a module's page element
        instance.addEndpoint(module.id, {
          uuid: endPoint,
          anchor: 'Bottom',
          maxConnections: -1
        }, {
          isSource: false,
          isTarget: true
        })
        instance.addEndpoint(module.id, {
          uuid: sourcePoint,
          anchor: 'Top',
          maxConnections: -1
        }, {
          isSource: true,
          isTarget: false
        })

        // since this function is recursive, modules with parents receive their parent from parentObject.
        if (parentObject !== null) {
          module.parent = _.clone(parentObject)
        }

        // if the module has children, it's now run on its children array.
        // parentObject is set to be this module to be sure child modules get a correctly labeled parent.
        if (module.children) {
          const parentObject = _.clone(module)
          delete parentObject.children
          delete parentObject.parent
          $this.addEndpoints(module.children, parentObject, instance)
        }
      })
    },

    /**
     * Connects modules to their children using svg lines
     * params: modules, jsPlumb instance
     * called by: createFlow()
     */
    connectModules (modules, instance) {
      const $this = this
      _.each(modules, function (module) {
        if (module.parent) {
          instance.connect({
            uuids: [`${module.parent.id}-bottom`, `${module.id}-top`]
          })
        }

        // if this module has children, run connectModules on them
        if (module.children) $this.connectModules(module.children, instance)


      })
    },

    /**
     * Called on mounted.
     * Centers modules on screen when page first loads.
     */
    centerView () {
      const windowWidth = $(window).width()
      const viewWidth = $('#modulesContainer').get(0).scrollWidth
      const modulesContainer = $('#modulesContainer')
      modulesContainer.scrollLeft((viewWidth - windowWidth) / 2)
    },

    /**
     * When window is resized, repaint jsPlumb elements
     */
    windowResized () {
      jsPlumb.repaintEverything()
    },

    /**
     * $emit toggleModulesSidebar to ModulesSidebar
     */
    toggleModulesSidebar (additionType, module) {
      const $this = this
      if (module) {
        $this.focusedModule = _.cloneDeep(module)
      }
      $this.addModulePopup = false
      $this.$emit('toggleModulesSidebar', $this.focusedModule.action_type, additionType)
    },

    /**
     * Recursively search an array of objects for a key/id pairing
     * params: array, key, value
     * returns: module or null
     **/
    getObject (array, key, value) {
      // console.log('getObject() — run seeking', `${key}: ${value}`)
      let o = null
      array.some(function iter (a) {
        // console.log('getObject() - existing ID', a[key])
        if (a[key] === value) {
          o = a
          return true
        }
        return Array.isArray(a.children) && a.children.some(iter)
      })
      return o
    },

    /**
     * Add child to selected module's children
     * params: parent id, module being added
     * calls: createFlow()
     * called by: addModuleChildrenToItsParent()
     **/
    addChild (parentId, newModule) {
      const $this = this
      let parent = null

      // pause jsPlumb painting until changes are finished to avoid multiple repaints
      jsPlumb.batch(function () {
        // if child to be added is trigger module
        if (newModule.type === 'trigger') {
          const children = $this.modules[0].children
          const triggerModule = newModule
          triggerModule.children = children
          $this.$set($this, 'modules', [triggerModule])
        }
        // if a parentId is supplied, create a reference to the parent module
        if (parentId) {
          parent = $this.getObject($this.modules, 'id', parentId)
          // if parentId is found in modules, add the new module to its children
          if (parent) {
            newModule.parent = parent
            parent.children.push(newModule)
          }
        // if there isn't a parentId, add the child to modules (technically no parent)
        } else if (newModule.type !== 'trigger') {
          parent = $this.modules
          parent.push(newModule)
        }
      })

      // run createFlow after Vue has a tick to reset its module element positions.
      $this.$nextTick(() => {
        $this.createFlow()
      })
    },

    /**
     * Add child between selected module and its children
     * params: parent id, module being added
     * calls: createFlow()
     **/
    addChildBetween (parentId, newModule) {
      const $this = this

      // create a reference to the parentId
      const parent = $this.getObject($this.modules, 'id', parentId)

      // copy the parent module's children over to the newModule's children
      newModule.children = parent.children

      // start a jsPlumb batch function to prevent the page from repainting
      jsPlumb.batch(function () {
        // redefine parent module's children to be a new array containing only the new module
        parent.children = [newModule]
      })
      // run createFlow after Vue has a tick to reset its module element positions.
      $this.$nextTick(() => {
        $this.createFlow()
      })
    },

    /**
     * Deletes the selected module
     * params: module to be deleted
     * calls: createFlow()
     */
    deleteModule (module) {

      const $this = this

      function continueDelete () {
        $this.addModuleChildrenToItsParent(module)
        let modulesCopy = _.cloneDeep($this.modules)

        // if the module to delete is the root, don't worry about searching deeper (saves time)
        if (modulesCopy[0].id === module.id) {
          modulesCopy = modulesCopy[0].children
        } else {

          // define a method to delete objects anywhere within the nested data
          const deleteNestedObj = (array, moduleId) => {
            array.children = array.children
              .filter((m) => { return m.id !== moduleId })
              .map((m) => { return deleteNestedObj(m, moduleId) })
            return array
          }

          // Use method to delete the module
          modulesCopy[0] = deleteNestedObj(modulesCopy[0], module.id)
        }

        // set modules data to match the edited copy
        $this.modules = modulesCopy

        // wait for Vue to update dom before re-flowing the nodes
        $this.$nextTick(() => {
          $this.createFlow()
        })
      }

      // Double-check with user before executing delete
      $this.$vs.dialog({
        'type': 'confirm',
        'color': 'danger',
        'title': 'Are you sure?',
        'text': 'If you delete this module, it\'s gone for good!',
        'accept': continueDelete
      })
    },

    /**
     * Copies a module's children to its parent module's children
     * useful when removing a module as it preserves the visual chain.
     * params: module
     * called by: deleteModule()
     */
    addModuleChildrenToItsParent (module) {
      const $this = this
      let children = null,
        parent = null

      // find the module in modules
      const foundModule = $this.getObject($this.modules, 'id', module.id)

      // if module ID isn't found, throw error.
      if (!foundModule) {
        console.error(`addModuleChildrenToItsParent() module ${module.id} not found. Canceling delete request.`)
        return
      }

      // if the found module has children, define children
      if (foundModule.children && foundModule.children.length) {
        children = foundModule.children
      }

      // if the found module has a parent, define parent
      if (foundModule.parent) {
        parent = foundModule.parent.id
      }

      // if the found module has both children and parents, add children to the parent
      if (children && parent) {
        _.each(children, (m) => {
          m.parent = foundModule.parent
          $this.addChild(parent, m)
        })

      }

      // if the found module has children but no parents, add children to the main container
      if (children && !parent) {
        parent = 'modules'
        _.each(children, (m) => {
          m.parent = null
          $this.addChild(null, m)
        })
      }
    },
    openAddModulePopup (module) {
      const $this = this
      $this.focusedModule = _.cloneDeep(module)
      if ($this.focusedModule.action_type === 'trigger-placeholder') {
        $this.focusedModule.action_type = 'standard'
      }
      $this.addModulePopup = true
    },
    openLogPopup (module) {
      const $this = this
      $this.focusedModule = _.cloneDeep(module)

      const destUrl = `${process.env.VUE_APP_API_ENDPOINT}/clik/${this.clikID}/queue/${this.exec_id}/${$this.focusedModule.id}`
      $this.$vs.loading()
      this.$http
        .get(destUrl, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        }).then(response => {
          console.log(response)

          /*$this.focusedModule.log = response.data.map(function (x) {
            return `[${new Date(x['timestamp']).toLocaleString()}] ${x['message']}`
          }).join('\n')*/

          $this.focusedModule.log = `[${new Date(response.data['timestamp']).toLocaleString()}] ${response.data['message']}`
          console.log(response.data)
          if ($this.focusedModule.log.length <= 0) {
            $this.focusedModule.log = 'No Logs...'
          }
          $this.$vs.loading.close()
          $this.logPopup = true
        })
        .catch(() => {
          $this.$vs.loading.close()
          $this.focusedModule.log = 'Error Retrieving Logs...'
          $this.logPopup = true
        })
     
    },
    openEditPopup (module) {
      const $this = this
      console.log('openEditPopup()', _.cloneDeep(module))
      $this.editPopup = true
      $this.focusedModule = _.cloneDeep(module)

    },
    updateEditPopupState (a) {
      const $this = this
      if ($this.editPopup !== a) {
        // console.log('GRID updateEditPopupState() run')
        $this.editPopup = a
      }
    },
    updateModule (module) {
      const $this = this

      // Get a ref to the module's parent
      const parent = () => {
        const p = $this.getObject($this.modules, 'id', module.parent.id)
        return p
      }

      // Create a copy of the parent's children
      const childrenCopy = _.cloneDeep(parent().children)

      //console.log('PARENT', _.cloneDeep(parent()))
      //console.log('CHILDREN', childrenCopy)

      // replace module (containing correct id) w/ updated module
      childrenCopy[childrenCopy.findIndex(child => child.id === module.id)] = module

      // replace the parent module's children with the updated children
      $this.$set(parent(), 'children', childrenCopy)
    },
    updateFocusedModule (module) {
      console.log('updateFocusedModule()', module)
      Object.assign(this.focusedModule, _.cloneDeep(module))
    },

    /**
     * TODO: This needs to actually be connected to a clik's id,
     * TODO: ID must be generated on clik creation
     */
    saveClik () {
      const $this = this
      console.log($this.modules)

      // function check (array) {
      //   _.each(array, item => {
      //     for (let prop in item) {
      //       if (typeof )
      //       console.log(`${prop}`)
      //     }

      //     if (item.children) {
      //       check(item.children)
      //     }
      //   })
      // }
      // check($this.modules)


      // const data = JSON.stringify($this.modules)
      // console.log('saveClik()', data)
      // $this.$http({
      //   method: 'put',
      //   url: `${process.env.VUE_APP_API_ENDPOINT}/clik/${$this.clik.id}`,
      //   data,
      //   headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
      // })
      //   .then(response => {
      //     console.log(response)
      //   })
      //   .catch((err) => console.log('api error occured', err))
    },
    downloadLog () {
      const $this = this
      const date = new Date().toJSON()
      const filename = `${$this.focusedModule.title}__log__${date}.txt`
      function forceFileDownload (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename) //or any other extension
        document.body.appendChild(link)
        link.click()
      }
      $this.$http({
        method: 'get',
        url: $this.downloadLogLink,
        responseType: 'arraybuffer'
      })
        .then(response => {
          forceFileDownload(response)
        })
        .catch(() => console.log('save error occured'))
    },
    copyLog () {
      const copyThis = document.querySelector('#log')
      copyThis.setAttribute('type', 'text')
      copyThis.select()

      try {
        document.execCommand('copy')
      } catch (err) {
        alert('Oops, unable to copy')
      }

      /* unselect the range */
      copyThis.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()

      // show alert
      this.$vs.notify({
        color: 'success',
        title: 'Copy Log',
        text: 'Success!'
      })
    }
  },
  mounted () {
    const $this = this
    $this.$nextTick(function () {
      window.addEventListener('resize', $this.windowResized)
    })

    jsPlumb.ready(() => {
      $this.createFlow()
    })
    $this.centerView()
  },
  directives: {
    dragscroll
  }
}
</script>

<style>

body {
  background: #e6ebf5;
}

.triggerText {
  color:#626262;
}

.textEmphasis {
  color: #7368F0;
}

.workflow_image {
  /* for IE10+ touch devices */
  touch-action:none;
}

.modulesContainer {
  position: fixed;
  left: 0px;
  right: 0px;
  top: 64px;
  bottom: 0;
  overflow: auto;
  background: #e6ebf5;
  padding-bottom: 250px;
}

.modules {
  position: relative;
  margin: 0 auto;
  z-index: 1;
  display: table;
}

/** For separating flows */
.modulesContainer li:not(.group-title), .modulesContainer li.addnewblock {
  position: relative;
  text-align: center;
  list-style-type: none;
  padding: 0;
}

.modulesContainer li.seriesblock {
  padding: 0 0 24px 0 !important;
}

ul.if-branches > * + * {
  margin-left: 40px !important;
}

.modulesContainer li.with-paths > ul, .modulesContainer li.with-paths > ul li.with-paths {
  position: relative;
  margin: 0 auto;
}

.modulesContainer ul.blocknode-paths:not(.has-multiple) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 70px;
}

.modulesContainer ul.blocknode-paths.has-multiple {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 100px;
}

/** Add new block button */
.modulesContainer li.addnewblock {
  padding: 0 0 24px 0 !important;
  min-height: 28px;
  min-width: 150px;
}

/** STANDARD MODULE **/
.modules .module {
  border:none;
  width: 320px;
  height: 102px;
  margin: 0 auto;
  line-height: 2em;
}

.module {
  display: block;
  background-color:white;
  border:1px solid #346789;
  text-align:center;
  z-index:24;
  cursor:pointer;
  -moz-border-radius:0.5em;
  border-radius:0.5em;
  position: relative;
  color: black;
  padding: 0 10px 0 20px;
  -webkit-transition: -webkit-box-shadow 0.15s ease-in;
  -moz-transition: -moz-box-shadow 0.15s ease-in;
  -o-transition: -o-box-shadow 0.15s ease-in;
  transition: box-shadow 0.15s ease-in;
}

.module:hover > .moduleButtons {
  height: 147px;
  opacity: 1;
}

.stepSuccess {
  box-shadow: 0 0 15px rgba(var(--vs-success), 1.0) !important;
}

.stepFailure {
  box-shadow: 0 0 15px rgba(var(--vs-danger), 1.0) !important;
}

.stepWaiting {
  box-shadow: 0 0 15px rgba(var(--vs-primary), 1.0) !important;
}

@keyframes blinkRunning {
    0% { box-shadow: 0 0 15px rgba(var(--vs-success)); }
    50% { box-shadow: none; }
    100% { box-shadow: 0 0 15px rgba(var(--vs-success)); }
}

@-webkit-keyframes blinkRunning {
    0% { box-shadow: 0 0 15px rgba(var(--vs-success)); }
    50% { box-shadow: 0 0 0; }
    100% { box-shadow: 0 0 15px rgba(var(--vs-success)); }
}
.stepRunning {
  -webkit-animation: blinkRunning 1.75s linear infinite;
    -moz-animation: blinkRunning 1.75s linear infinite;
    -ms-animation: blinkRunning 1.75s linear infinite;
    -o-animation: blinkRunning 1.75s linear infinite;
    animation: blinkRunning 1.75s linear infinite;
}

.module:hover:not(.trigger-placeholder) {
  box-shadow: 0 0 3px rgba(var(--vs-primary), 0.5);
}

.moduleContainer:hover > .module > .moduleButtons {
  position: absolute;
  bottom: -43px;
  margin-left: -20px;
  margin-right: -10px;
}

.moduleButtons {
  position: absolute;
  height: 102px;
  width: 320px;
  top: 0;
  margin-left: -20px;
  margin-right: -10px;
  opacity: 0;
  transition-property: height, opacity;
  transition-duration: .2s;
}

/** TRIGGER-PLACEHOLDER */
.modules .trigger-placeholder {
  width: 320px;
  height: 102px;
  margin: 0 auto;
  font-weight: bold;
  line-height: unset;
}

.trigger-placeholder {
  display: block;
  background-color: #e6ebf5;
  border: 8px solid rgb(200, 212, 234) !important;
  text-align: center;
  z-index: 24;
  cursor: pointer;
  -moz-border-radius: 51px;
  border-radius: 51px;
  position: relative;
  color: rgba(98, 98, 98, 1);
  padding: 0 20px 0 20px;
  -webkit-transition: -webkit-background-color 0.10s ease-in;
  -moz-transition:    -moz-background-color 0.10s ease-in;
  -o-transition:      -o-background-color 0.10s ease-in;
  transition:         background-color 0.10s ease-in;
}

.trigger-placeholder .moduleTitle {
  text-align: center;
  padding-top: 2px;
  width: 100%;
}

.trigger-placeholder:hover {
  background-color: rgb(200, 212, 234);;
}

.trigger-placeholder .moduleButtons {
  position: absolute;
  height: 102px;
  width: 320px;
  top: 0;
  margin-left: -28px;
  margin-right: -10px;
  opacity: 0;
  transition-property: height, opacity;
  transition-duration: .2s;
}

/** TRIGGER MODULE **/
.modules .trigger {
  border:none;
  width: 320px;
  height: 102px;
  margin: 0 auto;
  line-height: 2em;
}

.trigger {
  display: block;
  background-color: rgba(148, 162, 191, 1);
  border:1px solid #346789;
  text-align:center;
  z-index:24;
  cursor:pointer;
  -moz-border-radius: 51px;
  border-radius: 51px;
  position: relative;
  color: black;
  padding: 0 20px 0 30px;
  -webkit-transition: -webkit-box-shadow 0.15s ease-in;
  -moz-transition: -moz-box-shadow 0.15s ease-in;
  -o-transition: -o-box-shadow 0.15s ease-in;
  transition: box-shadow 0.15s ease-in;
}

.trigger:hover > .moduleButtons {
  height: 147px;
  opacity: 1;
}

.trigger:hover {
  box-shadow: 0 0 3px rgba(var(--vs-primary), 0.5);
}

.trigger .moduleTitle {
  text-align: center;
  font-weight: bold;
  color: white;
}

.moduleContainer:hover > .module > .moduleButtons {
  position: absolute;
  bottom: -43px;
  margin-left: -20px;
  margin-right: -10px;
}

.vs-avatar--con-img {
    border-radius: 50% !important;
    width: 32px;
    height: 32px;
}

.vs-avatar--con-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.moduleLogo .con-vs-avatar {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.endpoint > circle {
  fill: #A8A8A8;
}

.endpoint:not(.jtk-endpoint-connected) {
  display: none
}

/** MODULE CHIPS **/

.vs-avatar--con-img img {
  width: 32px;
}

.moduleLogo .con-vs-avatar {
  display: inherit;
}

/** Z-INDEX **/

._jsPlumb_connector { z-index:18; }
._jsPlumb_endpoint { z-index:21; }
._jsPlumb_overlay { z-index:19; }

.aLabel {
  background-color:white;
  padding:0.4em;
  font:12px sans-serif;
  color:#444;
  z-index:20;
  border:1px dotted gray;
  opacity:0.8;
  filter:alpha(opacity=80);
  cursor: pointer;
}
.aLabel._jsPlumb_hover {
  background-color:#5C96BC;
  color:white;
  border:1px solid white;
}

/** Popups */

.addModulePopup .vs-popup {
  width: 260px !important;
}

.logPopup .vs-popup {
  width: 80%;
}

.logPopup .vs-popup .vs-popup--content {
    margin: 0 0 1rem;
    padding: 0 0;
    width: 100%;
}

.addChildButton {
  height: 100px;
  width: 46%;
}

.terminal {
  background: rgb(var(--vs-dark));
  color: white;
  font-family: monospace;
  word-wrap: break-word;
  white-space: pre-wrap;
  width:100%;
  height: 70vh;
  padding: 1rem 1rem;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
}

.addChildButton svg {
  width: 100%;
  max-height: 60px;
}

.noHover {
  pointer-events: none;
}
</style>
